import { render, staticRenderFns } from "./coursePackage.vue?vue&type=template&id=96c5f07e&"
import script from "./coursePackage.vue?vue&type=script&lang=js&"
export * from "./coursePackage.vue?vue&type=script&lang=js&"
import style0 from "./coursePackage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports